import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createHead } from '@unhead/vue/client'
import { createPinia } from 'pinia'
import 'vue3-toastify/dist/index.css'  // Import styles
import Vue3Toastify from 'vue3-toastify'

const head = createHead()

const app = createApp(App)
app.use(router)
app.use(head)
app.use(createPinia())

// Global config (optional)
app.use(Vue3Toastify, {
  theme: "colored",
  autoClose: 3000,
  position: 'bottom-center',
  pauseOnHover: true,
  transition: "slide",
})


app.mount('#app')
